var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiverProblems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "71px",
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "909211DA-2EE6-4003-8E37-DF3BDC73AA57") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7---Warnings-and-precautions-for-Hana-",
    transform: "translate(-75.000000, -285.000000)",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(77.000000, 287.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.03641,33.5181 C67.03641,52.02975 52.02981,67.03635 33.51816,67.03635 C15.00666,67.03635 6e-05,52.02975 6e-05,33.5181 C6e-05,15.0066 15.00666,0 33.51816,0 C52.02981,0 67.03641,15.0066 67.03641,33.5181 Z",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.02406,42.282105 C27.10461,42.675405 27.14676,43.082655 27.14676,43.499655 C27.14676,46.836405 24.74031,49.541355 21.40371,49.541355",
    id: "Stroke-3",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.186385,20.07186 L47.101185,20.07186 C47.101185,20.07186 42.591885,19.57701 43.030335,18.26151 C43.468785,16.94601 44.443185,14.94846 44.443185,14.94846 L38.499135,13.38921 L36.062985,19.67451",
    id: "Stroke-5",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.739895,38.84295 L40.739895,55.77765 C40.739895,56.70345 39.145995,56.94705 39.145995,56.94705 C39.145995,56.94705 37.719495,56.8497 37.719495,55.33935 L37.719495,46.42365 C37.719495,44.328 37.453095,41.18025 34.175745,38.5884",
    id: "Stroke-7",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    stroke: "#222456",
    points: "29.668605 41.63172 29.668605 48.27447 32.701155 48.27447 32.701155 40.13277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07889,51.838305 L11.13729,51.838305 L11.13729,50.223705 L11.21304,50.071605 C12.10839,48.281805 12.58119,46.278405 12.58119,44.277855 L12.58119,35.233155 C12.58119,26.873355 19.38309,20.071905 27.74244,20.071905 L29.18634,20.071905 C32.76969,20.071905 35.68404,22.986105 35.68404,26.569455 L35.68404,33.927705 C35.68404,37.578855 33.21084,40.745955 29.66859,41.631705 L26.16594,42.507405 C23.26854,43.232505 21.24474,45.824955 21.24474,48.811605 L21.24474,49.672455 C21.24474,50.866455 20.27319,51.838305 19.07889,51.838305 Z",
    id: "Stroke-11",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75719,40.28685 L43.62579,40.28685 C41.63529,40.28685 40.01589,38.66745 40.01589,36.6771 L40.01589,28.01355 C40.01589,23.63475 43.57884,20.0718 47.95749,20.0718 L55.89909,20.0718 L55.89909,22.896 C55.89909,30.5742 51.06924,37.54395 43.87989,40.24065 L43.75719,40.28685 Z",
    id: "Stroke-13",
    stroke: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiverProblems);
export default __webpack_public_path__ + "static/media/liverProblems.d551a67e.svg";
export { ForwardRef as ReactComponent };